import { ConsentOrdersPathName } from "@fla/components";
import { ConsentOrdersLayout, DashboardLayout } from "components";
import { PrivateRoute } from "components/HOCs";
import { UserRoles } from "interfaces";
import AdditionalRequirementsPage from "pages/ConsentOrders/AssetsDebts/AdditionalRequirements";
import BankPage from "pages/ConsentOrders/AssetsDebts/Assets/Bank";
import AddBankPage from "pages/ConsentOrders/AssetsDebts/Assets/Bank/Add";
import BusinessPage from "pages/ConsentOrders/AssetsDebts/Assets/Business";
import AddBusinessPage from "pages/ConsentOrders/AssetsDebts/Assets/Business/Add";
import FurnitureAndPersonalPage from "pages/ConsentOrders/AssetsDebts/Assets/FurnitureAndPersonal";
import AddFurnitureAndPersonalPage from "pages/ConsentOrders/AssetsDebts/Assets/FurnitureAndPersonal/Add";
import InvestmentsPage from "pages/ConsentOrders/AssetsDebts/Assets/Investments";
import AddInvestmentsPage from "pages/ConsentOrders/AssetsDebts/Assets/Investments/Add";
import OverseasPage from "pages/ConsentOrders/AssetsDebts/Assets/OverseasAsset";
import AddOverseasPage from "pages/ConsentOrders/AssetsDebts/Assets/OverseasAsset/Add";
import RealEstatePage from "pages/ConsentOrders/AssetsDebts/Assets/RealEstate";
import AddRealEstatePage from "pages/ConsentOrders/AssetsDebts/Assets/RealEstate/Add";
import SuperannuationPage from "pages/ConsentOrders/AssetsDebts/Assets/Superannuation";
import AddSuperannuationPage from "pages/ConsentOrders/AssetsDebts/Assets/Superannuation/Add";
import VehiclePage from "pages/ConsentOrders/AssetsDebts/Assets/Vehicle";
import AddVehiclePage from "pages/ConsentOrders/AssetsDebts/Assets/Vehicle/Add";
import DebtsPage from "pages/ConsentOrders/AssetsDebts/Debts";
import DebtsAddPage from "pages/ConsentOrders/AssetsDebts/Debts/Add";
import AssetsDebtsSummaryPage from "pages/ConsentOrders/AssetsDebts/Summary";
import InitialDetails from "pages/ConsentOrders/InitialDetails";
//
import ConsentOrdersPage from "pages/ConsentOrders/Main";
import SubmitPage from "pages/ConsentOrders/Submit";
import WelcomePage from "pages/ConsentOrders/Welcome";
import DashboardPage from "pages/Dashboard";
import { Route } from "react-router-dom";

export const PrivateRoutes = () => [
  <Route
    key="/"
    path="/"
    element={
      <PrivateRoute layout={DashboardLayout} authorizedRoles={[UserRoles.user]}>
        <DashboardPage />
      </PrivateRoute>
    }
  />,
  <Route
    path={ConsentOrdersPathName.Default}
    key={ConsentOrdersPathName.Default}
    element={
      <PrivateRoute
        layout={ConsentOrdersLayout}
        authorizedRoles={[UserRoles.user]}
        layoutProps={{ bgColor: "bg-gray-light" }}
      >
        <ConsentOrdersPage />
      </PrivateRoute>
    }
  />,
  <Route
    path={ConsentOrdersPathName.Welcome}
    key={ConsentOrdersPathName.Welcome}
    element={
      <PrivateRoute layout={ConsentOrdersLayout} authorizedRoles={[UserRoles.user]}>
        <WelcomePage />
      </PrivateRoute>
    }
  />,
  <Route
    path={ConsentOrdersPathName.InitialDetails}
    key={ConsentOrdersPathName.InitialDetails}
    element={
      <PrivateRoute layout={ConsentOrdersLayout} authorizedRoles={[UserRoles.user]}>
        <InitialDetails />
      </PrivateRoute>
    }
  />,
  <Route
    path={ConsentOrdersPathName.RealEstate}
    key={ConsentOrdersPathName.RealEstate}
    element={
      <PrivateRoute layout={ConsentOrdersLayout} authorizedRoles={[UserRoles.user]}>
        <RealEstatePage />
      </PrivateRoute>
    }
  />,
  <Route
    path={`${ConsentOrdersPathName.RealEstate}/add`}
    key={`${ConsentOrdersPathName.RealEstate}/add`}
    element={
      <PrivateRoute layout={ConsentOrdersLayout} authorizedRoles={[UserRoles.user]}>
        <AddRealEstatePage />
      </PrivateRoute>
    }
  />,
  <Route
    path={ConsentOrdersPathName.Bank}
    key={ConsentOrdersPathName.Bank}
    element={
      <PrivateRoute layout={ConsentOrdersLayout} authorizedRoles={[UserRoles.user]}>
        <BankPage />
      </PrivateRoute>
    }
  />,
  <Route
    path={`${ConsentOrdersPathName.Bank}/add`}
    key={`${ConsentOrdersPathName.Bank}/add`}
    element={
      <PrivateRoute layout={ConsentOrdersLayout} authorizedRoles={[UserRoles.user]}>
        <AddBankPage />
      </PrivateRoute>
    }
  />,
  <Route
    path={ConsentOrdersPathName.Vehicle}
    key={ConsentOrdersPathName.Vehicle}
    element={
      <PrivateRoute layout={ConsentOrdersLayout} authorizedRoles={[UserRoles.user]}>
        <VehiclePage />
      </PrivateRoute>
    }
  />,
  <Route
    path={`${ConsentOrdersPathName.Vehicle}/add`}
    key={`${ConsentOrdersPathName.Vehicle}/add`}
    element={
      <PrivateRoute layout={ConsentOrdersLayout} authorizedRoles={[UserRoles.user]}>
        <AddVehiclePage />
      </PrivateRoute>
    }
  />,

  <Route
    path={ConsentOrdersPathName.Superannuation}
    key={ConsentOrdersPathName.Superannuation}
    element={
      <PrivateRoute layout={ConsentOrdersLayout} authorizedRoles={[UserRoles.user]}>
        <SuperannuationPage />
      </PrivateRoute>
    }
  />,
  <Route
    path={`${ConsentOrdersPathName.Superannuation}/add`}
    key={`${ConsentOrdersPathName.Superannuation}/add`}
    element={
      <PrivateRoute layout={ConsentOrdersLayout} authorizedRoles={[UserRoles.user]}>
        <AddSuperannuationPage />
      </PrivateRoute>
    }
  />,
  <Route
    path={ConsentOrdersPathName.Investments}
    key={ConsentOrdersPathName.Investments}
    element={
      <PrivateRoute layout={ConsentOrdersLayout} authorizedRoles={[UserRoles.user]}>
        <InvestmentsPage />
      </PrivateRoute>
    }
  />,
  <Route
    path={`${ConsentOrdersPathName.Investments}/add`}
    key={`${ConsentOrdersPathName.Investments}/add`}
    element={
      <PrivateRoute layout={ConsentOrdersLayout} authorizedRoles={[UserRoles.user]}>
        <AddInvestmentsPage />
      </PrivateRoute>
    }
  />,
  <Route
    path={ConsentOrdersPathName.Business}
    key={ConsentOrdersPathName.Business}
    element={
      <PrivateRoute layout={ConsentOrdersLayout} authorizedRoles={[UserRoles.user]}>
        <BusinessPage />
      </PrivateRoute>
    }
  />,
  <Route
    path={`${ConsentOrdersPathName.Business}/add`}
    key={`${ConsentOrdersPathName.Business}/add`}
    element={
      <PrivateRoute layout={ConsentOrdersLayout} authorizedRoles={[UserRoles.user]}>
        <AddBusinessPage />
      </PrivateRoute>
    }
  />,
  <Route
    path={ConsentOrdersPathName.Overseas}
    key={ConsentOrdersPathName.Overseas}
    element={
      <PrivateRoute layout={ConsentOrdersLayout} authorizedRoles={[UserRoles.user]}>
        <OverseasPage />
      </PrivateRoute>
    }
  />,
  <Route
    path={`${ConsentOrdersPathName.Overseas}/add`}
    key={`${ConsentOrdersPathName.Overseas}/add`}
    element={
      <PrivateRoute layout={ConsentOrdersLayout} authorizedRoles={[UserRoles.user]}>
        <AddOverseasPage />
      </PrivateRoute>
    }
  />,
  <Route
    path={ConsentOrdersPathName.Furniture}
    key={ConsentOrdersPathName.Furniture}
    element={
      <PrivateRoute layout={ConsentOrdersLayout} authorizedRoles={[UserRoles.user]}>
        <FurnitureAndPersonalPage />
      </PrivateRoute>
    }
  />,
  <Route
    path={`${ConsentOrdersPathName.Furniture}/add`}
    key={`${ConsentOrdersPathName.Furniture}/add`}
    element={
      <PrivateRoute layout={ConsentOrdersLayout} authorizedRoles={[UserRoles.user]}>
        <AddFurnitureAndPersonalPage />
      </PrivateRoute>
    }
  />,
  <Route
    path={ConsentOrdersPathName.Debts}
    key={ConsentOrdersPathName.Debts}
    element={
      <PrivateRoute layout={ConsentOrdersLayout} authorizedRoles={[UserRoles.user]}>
        <DebtsPage />
      </PrivateRoute>
    }
  />,
  <Route
    path={`${ConsentOrdersPathName.Debts}/add`}
    key={`${ConsentOrdersPathName.Debts}/add`}
    element={
      <PrivateRoute layout={ConsentOrdersLayout} authorizedRoles={[UserRoles.user]}>
        <DebtsAddPage />
      </PrivateRoute>
    }
  />,
  <Route
    path={ConsentOrdersPathName.AdditionalRequirements}
    key={ConsentOrdersPathName.AdditionalRequirements}
    element={
      <PrivateRoute layout={ConsentOrdersLayout} authorizedRoles={[UserRoles.user]}>
        <AdditionalRequirementsPage />
      </PrivateRoute>
    }
  />,
  <Route
    path={ConsentOrdersPathName.Summary}
    key={ConsentOrdersPathName.Summary}
    element={
      <PrivateRoute layout={ConsentOrdersLayout} authorizedRoles={[UserRoles.user]}>
        <AssetsDebtsSummaryPage />
      </PrivateRoute>
    }
  />,
  <Route
    path={ConsentOrdersPathName.Submit}
    key={ConsentOrdersPathName.Submit}
    element={
      <PrivateRoute layout={ConsentOrdersLayout} authorizedRoles={[UserRoles.user]}>
        <SubmitPage />
      </PrivateRoute>
    }
  />
];
